var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('spinner'):_c('faq-list-component',{attrs:{"faq-list":_vm.faqs,"page-info":{ totalCount: _vm.totalCount, page: _vm.page, size: _vm.size }},on:{"changePage":_vm.pageClick}})}
var staticRenderFns = []

export { render, staticRenderFns }